import React, { useState, useEffect } from "react";
import {
  Button,
  Icon,
  Grid,
  GridRow,
  GridColumn,
  Segment,
  Table,
  Popup,
} from "semantic-ui-react";
import { Permission, Role } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { BasicModal, ConfirmModal } from "../../../Shared";
import { PermissionForm } from "../PermissionForm";
import {
  convertModulesEngToEsp,
  convertActionsEngToEsp,
} from "../../../../utils/converts";
import {
  hasPermission,
  isAdmin,
  isMaster,
} from "../../../../utils/checkPermission";
import "./PermissionItem.scss";
import { useLanguage } from "../../../../contexts";

const permissionController = new Permission();
const roleController = new Role();

export function PermissionItem(props) {
  const { permission, onReload } = props;
  const {
    accessToken,
    user: { role },
  } = useAuth();

  const { translations } = useLanguage();
  
  const t = (key) => translations[key] || key ; // Función para obtener la traducción

  const [permissionsByRole, setPermissionsByRole] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");

  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [isDelete, setIsDelete] = useState(false);

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState);
  const onOpenCloseConfirm = () => setShowConfirm((prevState) => !prevState);

  useEffect(() => {
    (async () => {
      try {
        setPermissionsByRole([]);
        if (role) {
          const response = await permissionController.getMyPermissions(accessToken, true);
          setPermissionsByRole(response);
        }
      } catch (error) {
        console.error(error);
        setPermissionsByRole([]);
      }
    })();
  }, [role]);

  const openUpdateUser = () => {
    setTitleModal(`${t("update")}: ${t(permission.role.name.toLowerCase())} / ${t(permission.module)} / ${t(permission.action)}`);
    onOpenCloseModal();
  };

  const openDesactivateActivateConfim = () => {
    setIsDelete(false);
    setConfirmMessage(
      permission.active
        ? `¿${t("question_inactive")} "${t(permission.role.name.toLowerCase())} / ${t(permission.module)} / ${t(permission.action)}"?`
        : `¿${t("question_active")} "${t(permission.role.name.toLowerCase())} / ${t(permission.module)} / ${t(permission.action)}"?`
    );
    onOpenCloseConfirm();
  };

  const onActivateDesactivate = async () => {
    try {
      await permissionController.updatePermission(accessToken, permission._id, {
        active: !permission.active,
      });
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const openDeleteConfirm = () => {
    setIsDelete(true);
    setConfirmMessage(`${t("are_you_sure_you_want_to_remove_the_permission")} "${permission.role?.name || "sin nombre"} / ${t(permission.module)} / ${t(permission.action)}"?`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await permissionController.deletePermission(accessToken, permission._id);
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  // Helper para chequear permisos
const can = (action, resource = "permissions") => {
  return (
    isMaster(role) ||
    isAdmin(role) ||
    hasPermission(permissionsByRole, role._id, resource, action)
  );
};


  return (
    <>
      <Table.Row key={permission._id}>
        <Table.Cell>
          <span style={{
            display: "inline-block",
            padding: "3px 14px",
            borderRadius: "20px",
            fontSize: "12px",
            fontWeight: 600,
            backgroundColor: permission.active ? "#92FFBE" : "#FB8A8C",
            color: "#000",
          }}>
            {permission.active ? t("active") : t("inactive")}
          </span>
        </Table.Cell>
        {/* <Table.Cell>
          {permission.role && permission.role.name
            ? t(permission.role.name.toLowerCase())
            : null}
        </Table.Cell> */}
        {/* <Table.Cell>{t(permission.module)}</Table.Cell> */}
        <Table.Cell>{t(permission.action)}</Table.Cell>
        <Table.Cell>
          {can("edit") && (
  <Popup
    content={t("edit")}
    trigger={
      <Button icon primary onClick={openUpdateUser}>
        <Icon name="pencil" />
      </Button>
    }
  />
)}

{can("edit") && (
  <Popup
    content={permission.active ? t("deactivate") : t("activate")}
    trigger={
      <Button
        icon
        color={permission.active ? "orange" : undefined}
        style={permission.active ? undefined : { backgroundColor: "#1BC5A6", color: "#fff" }}
        onClick={openDesactivateActivateConfim}
      >
        <Icon name={permission.active ? "ban" : "check"} />
      </Button>
    }
  />
)}

{can("delete") && (
  <Popup
    content={t("delete")}
    trigger={
      <Button icon color="red" onClick={openDeleteConfirm}>
        <Icon name="trash" />
      </Button>
    }
  />
)}

        </Table.Cell>
      </Table.Row>

      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal} size="tiny">
        <PermissionForm
          close={onOpenCloseModal}
          onReload={onReload}
          permission={permission}
        />
      </BasicModal>

      <ConfirmModal
        open={showConfirm}
        title={isDelete ? t("delete") : t("activate_deactivate")}
        content={confirmMessage}
        onConfirm={isDelete ? onDelete : onActivateDesactivate}
        onCancel={onOpenCloseConfirm}
        danger={isDelete}
      />
    </>
  );
}
